// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mf-1";
export var spinner = "_mf-0";